export default __webpack_public_path__ + "static/media/t7.cf425819.png";